import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconArrowOutwardLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m16.144 7.804-9.332 9.323a.693.693 0 0 1-.522.203.725.725 0 0 1-.523-.213.703.703 0 0 1-.207-.517c0-.206.069-.379.207-.517l9.324-9.333H6.894a.726.726 0 0 1-.534-.216A.726.726 0 0 1 6.144 6c0-.213.072-.391.216-.535a.726.726 0 0 1 .534-.215h9.846c.256 0 .471.087.644.26.174.173.26.388.26.644V16c0 .212-.072.39-.215.534a.726.726 0 0 1-.535.216.725.725 0 0 1-.534-.216.726.726 0 0 1-.216-.534V7.804Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconArrowOutwardLine;
